import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer-section" className="py-20 md:py-24 px-6 bg-navy text-white relative overflow-hidden" data-id="element-66">
      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-67"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-68">
        <FadeIn data-id="element-69">
          <h2 className="font-serif text-3xl md:text-5xl mb-8" data-id="element-70">
            Recupera el dominio de tu mañana hoy mismo.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-71">
          <p className="text-lg text-white/80 mb-12 max-w-2xl mx-auto" data-id="element-72">
            El acceso al Método 7-D Mornings completo tiene un valor simbólico
            para asegurar que nadie se quede fuera por falta de recursos.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-73">
          <div id="offer-cta" className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-12 backdrop-blur-sm max-w-xl mx-auto mb-12" data-id="element-74">
            <p className="text-white/60 uppercase tracking-widest text-sm mb-4 font-medium" data-id="element-75">
              Precio Único
            </p>
            <div className="flex flex-col items-center gap-2 mb-8" data-id="element-76">
              <div className="flex items-center gap-2" data-id="element-77">
                <span className="text-2xl text-white/40 font-serif line-through" data-id="element-78">
                  $17
                </span>
                <span className="text-sm uppercase tracking-wider bg-gold/20 text-gold px-3 py-1 rounded-full font-semibold" data-id="element-79">
                  -63% OFF
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-80">
                <span className="text-3xl text-gold font-serif" data-id="element-81">$</span>
                <span className="text-6xl md:text-7xl font-serif text-white" data-id="element-82">
                  6.36
                </span>
                <span className="text-xl text-white/60 self-end mb-2" data-id="element-83">USD</span>
              </div>
            </div>

            <CTAButton href="https://inerciacero.com/cart/42357278605415:1" onClick={() => trackAddToCart()} className="w-full" data-id="element-84">
              QUIERO RECUPERAR MIS MAÑANAS
            </CTAButton>

            <p className="mt-6 text-sm text-white/50" data-id="element-85">
              Tu transformación comienza mañana a primera hora.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}